module.exports = require('./helpers/bundle-url').getBundleURL('l1An2') + "logo-dark.eefe0b7f.svg";